import { useInviteWebsite, siteLabel } from "../../hooks/useInviteWebsite";

/** Fan pages: clickable "Powered by HoopsHQ" pointing at the admin-set website (hoopshq.net). */
export const PoweredByLink = ({ className = "" }) => {
  const site = useInviteWebsite();
  return (
    <a href={site} target="_blank" rel="noreferrer" data-testid="powered-by-hoopshq" className={`inline-flex items-center gap-1.5 text-sm text-slate-400 transition-colors hover:text-white ${className}`}>
      Powered by <span className="font-display font-black uppercase tracking-wide text-white">Hoops<span className="text-[#39FF14]">HQ</span></span>
      <span className="font-mono-gd text-xs text-slate-400">{siteLabel(site)}</span>
    </a>
  );
};

/** Share graphics: the same credit as plain text so the image always points back to the site. */
export const PoweredByMark = ({ testid }) => {
  const site = useInviteWebsite();
  return (
    <p data-testid={testid} className="font-mono-gd text-[8px] uppercase tracking-[0.2em] text-slate-300">
      Powered by <span className="font-bold text-white">Hoops<span className="text-[#39FF14]">HQ</span></span> · {siteLabel(site)}
    </p>
  );
};
